import ReactDOM from 'react-dom';

import { Root } from './Root';

ReactDOM.render(<Root />, document.getElementById('root'));
